import Splide from '@splidejs/splide';

export const testimonialsSlider = (selector) => {
    jQuery(document).ready(function ($) {
        new Splide( selector, {
            type   : 'loop',
            focus  : 1,
            drag   : 'free',
            snap   : true,
            pagination: true,
            updateOnMove: true,
            autoplay: true,
            arrows: false,
            perPage: 3,
            perMove: 1,
            flickPower: 100,
            gap: '50px',
            breakpoints: {
                1400: {
                    perPage: 2
                },
                992: {
                    perPage: 2,
                    gap: '30px'
                },
                850: {
                    perPage: 1
                }
            }
        }).mount();
    });
};